/* eslint-disable import/no-duplicates */
import { createContext, useContext } from 'react';
import LoginStore from './Login/loginStore';
import CommonStore from './commonStore';
import PermissionStore from './permissionStore';
import LanguageStore from './languageStore';
import RoleStore from './roleStore/roleStore';
import UserStore from './userStore/userStore';

// Archive

import YearStore from './Year/YearStore';
import commonDropdown from './CommonDropdwon/commonDropdown';

import userPerformenceDashboardStore from './userPerformenceDashboard/userPerformenceDashboardStore';

import EmployeeStore from './Employee/EmployeeStore';

import ProvinceStore from './Province/ProvinceStore';

import DistrictStore from './District/DistrictStore';
import ContractTypeStore from './ContractType/ContractTypeStore';

import ContractDetailsStore from './ContractDetails/ContractDetailsStore';

import PositionTitleStore from './PositionTitle/PositionTitleStore';
import JobPositionStore from './JobPosition/JobPositionStore';

import ApplicationStore from './applicationStore';

import TrainingVideoStore from './foamCompanyStores/TrainingVideoStore';
import BlockStore from './Choqorak/Settings/BlockStore';
import ContractInfoStore from './Choqorak/MainTables/Contract/ContractInfoStore';
import CustomerStore from './Choqorak/MainTables/Contract/CustomerStore';
import ContractPaymentStore from './Choqorak/MainTables/Finance/ContractPaymentStore';
import DiscountStore from './Choqorak/MainTables/Finance/DiscountStore';
import FinanceReportStore from './Choqorak/MainTables/Finance/FinanceReportStore';
import IncomeReportStore from './Choqorak/MainTables/Income/IncomeReportStore';
import IncomeStore from './Choqorak/MainTables/Income/IncomeStore';
import MapStore from './Choqorak/MainTables/Map/MapStore';
import ShopReportStore from './Choqorak/MainTables/Shop/ShopReportStore';
import ShopStore from './Choqorak/MainTables/Shop/ShopStore';
import ElectricBoxStore from './Choqorak/Settings/ElectricBoxStore';
import ElectricMeterStore from './Choqorak/Settings/ElectricMeterStore';
import FloorStore from './Choqorak/Settings/FloorStore';
import IncomeCategoryStore from './Choqorak/Settings/IncomeCategoryStore';
import ShopContractTypeStore from './Choqorak/Settings/ShopContractTypeStore';
import ShopTypeStore from './Choqorak/Settings/ShopTypeStore';
import ChoqorakCommonDDL from './Choqorak/ChoqorakCommonDropdwon/ChoqorakCommonDropdown';
import StatusStore from './Choqorak/Settings/StatusStore';
import RentPaymentStore from './Choqorak/MainTables/RentPayment/RentPaymentStore';
import TermsAndConditionStore from './Choqorak/Settings/TermsAndConditionStore';
import ElectricityPaymentStore from './Choqorak/MainTables/ElectricityPayment/ElectricityPaymentStore';
import Dashboardstore from './Choqorak/Dashboards/Dashboardstore';
import notificationStore from './notificationStore/notificationStore';
import FinancialPaymentStore from './Choqorak/MainTables/FinancialPayment/FinancialPaymentStore';

interface Store {
  LoginStore: LoginStore;
  CommonStore: CommonStore;
  PermissionStore: PermissionStore;
  LanguageStore: LanguageStore;
  RoleStore: RoleStore;
  UserStore: UserStore;

  //Archive
  YearStore: YearStore;

  // Common Drop Down For All System
  commonDropdown: commonDropdown;

  // user Performence Dashboard and Report
  userPerformenceDashboardStore: userPerformenceDashboardStore;

  // Reception Reports

  // Employee
  EmployeeStore: EmployeeStore;

  ContractDetailsStore: ContractDetailsStore;

  // User Dashboard

  // Province
  ProvinceStore: ProvinceStore;
  // District
  DistrictStore: DistrictStore;

  //ContractType
  ContractTypeStore: ContractTypeStore;

  PositionTitleStore: PositionTitleStore;

  JobPositionStore: JobPositionStore;

  ApplicationStore: ApplicationStore;

  TrainingVideoStore: TrainingVideoStore;

  BlockStore: BlockStore;
  ContractInfoStore: ContractInfoStore;
  CustomerStore: CustomerStore;
  ContractPaymentStore: ContractPaymentStore;
  DiscountStore: DiscountStore;
  FinanceReportStore: FinanceReportStore;
  IncomeStore: IncomeStore;
  IncomeReportStore: IncomeReportStore;
  MapStore: MapStore;
  ShopStore: ShopStore;
  ShopReportStore: ShopReportStore;

  ElectricBoxStore: ElectricBoxStore;
  ElectricMeterStore: ElectricMeterStore;
  FloorStore: FloorStore;
  IncomeCategoryStore: IncomeCategoryStore;
  ShopContractTypeStore: ShopContractTypeStore;
  StatusStore: StatusStore;
  ShopTypeStore: ShopTypeStore;
  RentPaymentStore: RentPaymentStore;
  TermsAndConditionStore: TermsAndConditionStore;
  ChoqorakCommonDropdown: ChoqorakCommonDDL;
  ElectricityPaymentStore: ElectricityPaymentStore;
  Dashboardstore: Dashboardstore;
  notificationStore: notificationStore;
  FinancialPaymentStore: FinancialPaymentStore;
}
//Include All store below
export const store: Store = {
  LoginStore: new LoginStore(),
  CommonStore: new CommonStore(),
  commonDropdown: new commonDropdown(),
  PermissionStore: new PermissionStore(),
  LanguageStore: new LanguageStore(),
  RoleStore: new RoleStore(),
  UserStore: new UserStore(),
  //Archive
  YearStore: new YearStore(),
  userPerformenceDashboardStore: new userPerformenceDashboardStore(),

  //Employee
  EmployeeStore: new EmployeeStore(),
  ContractDetailsStore: new ContractDetailsStore(),

  // User Dashboardstore

  // PMIS
  ProvinceStore: new ProvinceStore(),
  DistrictStore: new DistrictStore(),

  //ContractType
  ContractTypeStore: new ContractTypeStore(),

  PositionTitleStore: new PositionTitleStore(),

  JobPositionStore: new JobPositionStore(),
  // Foam Company Stores

  ApplicationStore: new ApplicationStore(),

  TrainingVideoStore: new TrainingVideoStore(),

  BlockStore: new BlockStore(),
  ContractInfoStore: new ContractInfoStore(),
  CustomerStore: new CustomerStore(),
  ContractPaymentStore: new ContractPaymentStore(),
  DiscountStore: new DiscountStore(),
  FinanceReportStore: new FinanceReportStore(),
  IncomeStore: new IncomeStore(),
  IncomeReportStore: new IncomeReportStore(),
  MapStore: new MapStore(),
  ShopStore: new ShopStore(),
  ShopReportStore: new ShopReportStore(),

  ElectricBoxStore: new ElectricBoxStore(),
  ElectricMeterStore: new ElectricMeterStore(),
  FloorStore: new FloorStore(),
  IncomeCategoryStore: new IncomeCategoryStore(),
  ShopContractTypeStore: new ShopContractTypeStore(),
  StatusStore: new StatusStore(),
  ShopTypeStore: new ShopTypeStore(),
  RentPaymentStore: new RentPaymentStore(),
  TermsAndConditionStore: new TermsAndConditionStore(),
  ChoqorakCommonDropdown: new ChoqorakCommonDDL(),
  ElectricityPaymentStore: new ElectricityPaymentStore(),
  Dashboardstore: new Dashboardstore(),
  notificationStore: new notificationStore(),
  FinancialPaymentStore: new FinancialPaymentStore(),
};

export const StoreContext = createContext(store);
export function useStore() {
  return useContext(StoreContext);
}
